module.exports = __webpack_public_path__ + "static/img/AboutUS.104cfa2a.jpg";